<!--
    This is an extremely simple tooltip made specifically for stock availability messages.
    This component attaches to the nearest parent with a limiting position attribute.
    Use the "position:relative trick" to force the direct parent to limit the position.

    This could be improved by using Popper.js or just using a library that includes a tooltip.
-->

<template>
    <div
        role="tooltip"
        class="absolute z-10 py-1 px-2 text-xs font-medium text-white rounded shadow-md tooltip"
        :class="variant_classes"
    >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['variant'],

        computed: {
            variant_classes () {
                if (this.variant == 'danger') return ' bg-red-600';
                else return ' bg-gray-darker';
            }
        }
    }
</script>

<style scoped>
    .tooltip
    {
        top: -28px;
        left: 50%;
        transform: translate(-50%);
        white-space: nowrap;
    }
</style>